import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarComponent {
  @Input() value = 0;
  @Input() barColor = 'var(--color-primary)';
  @Input() dangerThreshold = 0.9;
  @Input() height = 6;

  get clampedValue(): number {
    return Math.max(0, Math.min(1, this.value));
  }

  get displayColor(): string {
    return this.value >= this.dangerThreshold
      ? 'var(--color-danger, #e53935)'
      : this.barColor;
  }

  get widthPercent(): string {
    return `${this.clampedValue * 100}%`;
  }
}
